export const apiService = {
  async getAvailableYears(groupId) {
    try {
      const res = await fetch(
        `https://dashboards.workanthem.com/api/available-years?groupId=${groupId}`,
        { cache: "no-store" }
      );
      if (!res.ok) throw new Error("Failed to fetch available years");

      const data = await res.json();
      return data.years || [];
    } catch (error) {
      console.error("Error fetching available years:", error);
      return [];
    }
  },

  async getCurrency(groupId) {
    try {
      const res = await fetch(
        `https://dashboards.workanthem.com/api/currency?groupId=${groupId}`
      );
      if (!res.ok) throw new Error("Failed to fetch currency");
      return await res.json();
    } catch (error) {
      console.error("Error fetching currency:", error);
      return { currency: "" };
    }
  },

  // Fetch daily expenses for DailyExpenseChart
  async getDailyExpenses(groupId, year, month) {
    try {
      const res = await fetch(
        `https://dashboards.workanthem.com/api/monthly-credit-debit?groupId=${groupId}&year=${year}&month=${month}`,
        { cache: "no-store" }
      );
      if (!res.ok) throw new Error("Failed to fetch daily expenses");
      return await res.json();
    } catch (error) {
      console.error("Error fetching daily expenses:", error);
      return [];
    }
  },

  // Fetch category-wise expenses for HighLevelPieChart & KPI
  async getExpenseByMonth(groupId, year, month) {
    try {
      const res = await fetch(
        `https://dashboards.workanthem.com/api/expense-monthswise?groupId=${groupId}&year=${year}&months=${month}`,
        { cache: "no-store" }
      );
      if (!res.ok) throw new Error("Failed to fetch expense by month");
      return await res.json();
    } catch (error) {
      console.error("Error fetching expense by month:", error);
      return [];
    }
  },

  async getYearlyCreditDebit(groupId, year) {
    try {
      const res = await fetch(
        `https://dashboards.workanthem.com/api/yearly-credit-debit?groupId=${groupId}&year=${year}`,
        { cache: "no-store" }
      );
      if (!res.ok) throw new Error("Failed to fetch yearly credit debit");
      return await res.json();
    } catch (error) {
      console.error("Error fetching yearly credit debit:", error);
      return { credit: [], debit: [] };
    }
  },

  async getYearlyExpense(groupId, year) {
    try {
      const res = await fetch(
        `https://dashboards.workanthem.com/api/yearly-expense?groupId=${groupId}&year=${year}`,
        { cache: "no-store" }
      );
      if (!res.ok) throw new Error("Failed to fetch yearly expense data");
      return await res.json();
    } catch (error) {
      console.error("Error fetching yearly expense data:", error);
      return [];
    }
  },

  async getCategoryExpenses(groupId, year) {
    try {
      const res = await fetch(
        `https://dashboards.workanthem.com/api/category-expenses?groupId=${groupId}&year=${year}`,
        { cache: "no-store" }
      );
      if (!res.ok) throw new Error("Failed to fetch category expenses");
      return await res.json();
    } catch (error) {
      console.error("Error fetching category expenses:", error);
      return [];
    }
  },

  async getAnnualCategoryTrends(groupId, year) {
    try {
      const res = await fetch(
        `https://dashboards.workanthem.com/api/annual-category-trends?groupId=${groupId}&year=${year}`,
        { cache: "no-store" }
      );
      if (!res.ok) throw new Error("Failed to fetch annual category trends");
      return await res.json();
    } catch (error) {
      console.error("Error fetching annual category trends:", error);
      return { categories: [], data: [] };
    }
  },

  async getTreeGraphData(groupId, years, currency) {
    try {
      const yearParams = years.join(",");
      const res = await fetch(
        `https://dashboards.workanthem.com/api/treegraph?groupId=${groupId}&years=${yearParams}&currency=${currency}`,
        { cache: "no-store" }
      );
      if (!res.ok) throw new Error("Failed to fetch tree graph data");
      return await res.json();
    } catch (error) {
      console.error("Error fetching tree graph data:", error);
      return [];
    }
  },

  async getNetBalance(groupId, year) {
    try {
      const res = await fetch(
        `https://dashboards.workanthem.com/api/net-balance?groupId=${groupId}&year=${year}`,
        { cache: "no-store" }
      );
      if (!res.ok) throw new Error("Failed to fetch net balance data");
      return await res.json();
    } catch (error) {
      console.error("Error fetching net balance data:", error);
      return [];
    }
  },

  // Stats for UniqueStatCards
  async getYearlyStats(groupId, year) {
    try {
      const res = await fetch(
        `https://dashboards.workanthem.com/api/yearly-expense?groupId=${groupId}&year=${year}`,
        { cache: "no-store" }
      );
      if (!res.ok) throw new Error("Failed to fetch yearly stats");
      return await res.json();
    } catch (error) {
      console.error("Error fetching yearly stats:", error);
      return [];
    }
  },

  async getFinancialInsights(groupId, year, month) {
    try {
      const res = await fetch(
        `https://dashboards.workanthem.com/api/financial-insights?groupId=${groupId}&year=${year}&month=${month}`,
        { cache: "no-store" }
      );
      if (!res.ok) throw new Error("Failed to fetch financial insights");
      return await res.json();
    } catch (error) {
      console.error("Error fetching financial insights:", error);
      return {
        highestDebitMonth: { month: "N/A", amount: 0 },
        lowestDebitMonth: { month: "N/A", amount: 0 },
        highestCreditMonth: { month: "N/A", amount: 0 },
        lowestCreditMonth: { month: "N/A", amount: 0 },
        avgDebit: { amount: 0, transactionCount: 0 },
        avgCredit: { amount: 0, transactionCount: 0 },
        thisMonthTrend: { trend: "N/A", percentageChange: 0 },
        topSpendingCategory: { category: "N/A", percentage: 0 },
        incomeVsExpense: { ratio: "N/A", percentageHigher: 0 },
      };
    }
  },

  async getYearlyCategoryExpenses(groupId, years) {
  if (!years || years.length === 0) {
    const currentYear = new Date().getFullYear();
    years = [currentYear];
  }

  const res = await fetch(
    `https://dashboards.workanthem.com/api/yearly-category-expenses?groupId=${groupId}&years=${years.join(',')}`,
    { cache: "no-store" }
  );

  return await res.json();
},

};
